import { useTranslation } from 'react-i18next';
import { ActionsColumn as ActionsColumnCommon, ActionType } from '@otp/ui';
import { Archive, Configure, Remove } from '@otp/icons';
import styles from './index.module.css';
import React from 'react';
import { ActionModals, PermissionAction } from './actions-modals';
import { PermissionListItem } from 'src/components/permissions/list/types';
import { PermissionType } from 'src/graphql/generated/graphql';

type ActionsColumProps = {
  permission: PermissionListItem;
  onActionFinished?: (action: PermissionAction) => void;
};

export const ActionsColumn = ({
  permission,
  onActionFinished,
}: ActionsColumProps) => {
  const { t } = useTranslation();
  const [action, setAction] = React.useState<PermissionAction>();
  const isSystemPermission = permission.type === PermissionType.System;

  const actions = [
    {
      id: PermissionAction.Edit,
      label: t('common.edit'),
      icon: <Configure />,
      onClick: () => setAction(PermissionAction.Edit),
    },
    !isSystemPermission && {
      id: PermissionAction.Delete,
      label: !permission.isDeleted ? t('common.delete') : t('common.restore'),
      icon: <Remove />,
      onClick: () => {
        setAction(
          permission.isDeleted
            ? PermissionAction.Restore
            : PermissionAction.Delete,
        );
      },
    },
    !isSystemPermission && {
      id: PermissionAction.Disable,
      label: !permission.isDisabled ? t('common.disable') : t('common.enable'),
      icon: <Archive />,
      onClick: () => {
        setAction(
          !permission.isDisabled
            ? PermissionAction.Disable
            : PermissionAction.Enable,
        );
      },
    },
  ].filter(Boolean) as ActionType[];

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <ActionsColumnCommon
        actions={actions}
        classes={{ menu: styles.actionsColumn }}
      />
      {action && (
        <ActionModals
          permission={permission}
          onClose={() => setAction(undefined)}
          action={action}
          onActionFinished={onActionFinished}
        />
      )}
    </div>
  );
};
